/**
 * Collects any <script data-faq-entry> fragments rendered by the
 * 'collapsible-row' block (when its "Include in FAQ structured data" setting
 * is on) and combines them into a single, valid FAQPage JSON-LD block for
 * the current page. Runs on every page but does nothing when no FAQ entries
 * are present.
 */
document.addEventListener('DOMContentLoaded', () => {
  const entries = document.querySelectorAll('script[data-faq-entry]');
  if (!entries.length) return;

  const mainEntity = [];

  entries.forEach((entry) => {
    let data;
    try {
      data = JSON.parse(entry.textContent);
    } catch (error) {
      return;
    }

    if (!data || !data.question || !data.answer) return;

    mainEntity.push({
      '@type': 'Question',
      name: data.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: data.answer,
      },
    });
  });

  if (!mainEntity.length) return;

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity,
  };

  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.id = 'faq-page-schema';
  script.textContent = JSON.stringify(schema);
  document.head.appendChild(script);
});
